import classNames from 'classnames';
import Component from './Component';
import immutable from 'immutable';
import React from 'react';
import uuid from 'uuid';
import {ProgressBar} from 'react-bootstrap';

class Mp4Upload extends Component {

	static contextTypes = {
		store: React.PropTypes.object,
	};

	constructor(props) {
		super(props);
		this.uid = uuid.v4();
		this.state = {
			busy: false,
			overed: false,
			files: [],
			value: props.value ? props.value.toJS() : null
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({value: nextProps.value ? nextProps.value.toJS() : null});
	}

	componentDidMount() {
		this.uploader = new plupload.Uploader({
			runtimes : 'html5,html4',
			multi_selection: false,
			unique_names: true,
			drop_element: this.uid + "_dropzone",
			browse_button : this.uid + '_pickfiles',
			url : '/upload/video-upload',
			filters : {
				max_file_size : '100mb',
				mime_types: [
					{ title : "Video files", extensions : "mp4,MP4"}
				]
			},
			init: {
				FilesAdded: (up, files) => {
					// Pokud už je video nahráno, nepovolit další upload
					if (this.state.value) {
						return;
					}
					plupload.each(files, (file) => {
						this.handleFileAdd(file);
					});
					this.startUpload();
				},

				FileUploaded: this.handleFileUploaded.bind(this),
				UploadProgress: this.handleUploadProgress.bind(this),
				UploadComplete: this.handleUploadComplete.bind(this),

				Error: function(up, err) {
					alert(err.message);
				},

				init:() => {
					this.uploaderInited = true;
					if (this.uploaderDestroyed) {
						this.uploader.destroy();
					}
				}
			}
		});
		this.uploader.init();
	}

	componentWillUnmount() {
		if (this.uploaderInited) {
			this.uploader.destroy();
		}
		else {
			this.uploaderDestroyed = true;
		}
	}

	startUpload() {
		this.setState({busy: true});
		this.uploader.start();
	}

	handleFileAdd(file) {
		this.state.files = [];
		this.state.files.push(file);
		this.forceUpdate();
	}

	handleUploadProgress(up, file) {
		this.forceUpdate();
	}

	handleFileUploaded(up, file, response) {
		response = JSON.parse(response.response);
		this.setState({
			value: {
				id: response.id,
				url: response.url,
				file: response.file,
				width: response.width,
				height: response.height,
				duration: response.duration
			}
		});
	}

	handleUploadComplete(up, files) {
		this.setState({files: [], busy: false});
		const value = immutable.fromJS(this.state.value);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	handleClick(e) {
		e.nativeEvent.stopImmediatePropagation();
	}

	handleReset() {
		if (this.props.onChange) {
			this.props.onChange(null);
		}
		if (this.props.onBlur) {
			this.props.onBlur(null);
		}
	}

	dragEnter(e){
		this.setState({overed:true});
	}

	dragLeave(e){
		this.setState({overed:false});
	}

	formatDuration(seconds) {
		if (!seconds) return '';
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${mins}:${secs.toString().padStart(2, '0')}`;
	}

	renderInput() {
		let p;
		if (this.state.files.length) {
			const file = this.state.files[0];
			if (file.status != plupload.DONE) {
				p = <ProgressBar style={{marginTop:10}} bsStyle="success" now={file.percent} label={file.percent + '%'} />
			}
		}

		var preview;
		if (this.state.value) {
			const videoStyle = {
				maxWidth: 320,
				maxHeight: 180
			};
			preview = (
				<div style={{float:'left', position:'relative'}} className="video-preview">
					<span
						onClick={() => this.handleReset()}
						className="remove-video fa fa-times-circle"
						style={{
							position: 'absolute',
							zIndex: 10,
							top: -8,
							right: -8,
							fontSize: 20,
							cursor: 'pointer',
							color: '#c00',
							background: '#fff',
							borderRadius: '50%'
						}}
						title="Odstranit video"
					/>
					<video
						src={this.state.value.url}
						style={videoStyle}
						controls
						preload="metadata"
					/>

				</div>
			);
		}

		return (
			<div onClick={this.handleClick} className="mp4upload">
				<div className="picturepreview">
					{preview}
					<div className="cleaner"></div>
				</div>
				<div id={this.uid + '_dropzone'}
					 style={{display: this.state.value ? 'none' : 'block'}}
					 onDragEnter={(e) => this.dragEnter(e)}
					 onDrop={(e) => this.dragLeave(e)}
					 onDragLeave={(e) => this.dragLeave(e)}>
					<div id={this.uid + '_pickfiles'} className={classNames('btn btn-default dropzone', {'overed': this.state.overed})}>
						<div style={{pointerEvents: 'none'}}>
							 Vybrat video z disku
						</div>
						<div style={{pointerEvents: 'none', fontSize:10, textAlign:'center'}}>nebo přetáhněte soubor sem</div>
					</div>
				</div>
				<div>{p}</div>
			</div>
		);
	}

	renderError() {
		return this.props.error ? (
			<span className="error-block" key="error">
				{this.props.error}
			</span>
		) : null;
	}

	renderWrapper(children) {
		return this.props.wrapperClassName ? (
			<div className={this.props.wrapperClassName} key="wrapper">
				{children}
			</div>
		) : children;
	}

	renderFormGroup(children) {
		var classes = {
			'form-group': false,
			'has-feedback': this.props.hasFeedback,
			'has-success': this.props.bsStyle === 'success',
			'has-warning': this.props.bsStyle === 'warning',
			'has-error': this.props.bsStyle === 'error'
		};
		classes[this.props.groupClassName] = this.props.groupClassName;

		return (
			<div className={classNames(classes)}>
				{children}
			</div>
		);
	}

	render() {
		return this.renderFormGroup([
			this.renderWrapper([
				this.renderInput()
			]),
			this.renderError()
		]);
	}
}

export default Mp4Upload;



// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/Mp4Upload.js